<template>
  <van-popup
    v-model="show"
    class="scoreSearch"
    :overlay="false"
    position="right"
    lock-scroll
  >
    <van-nav-bar
      class="search-nav"
      right-text="搜索"
      left-arrow
      @click-left="close"
    >
      <van-search
        slot="title"
        ref="searchInput"
        v-model="inputValue"
        class="search-field"
        placeholder="请输入发言人姓名"
        maxlength="50"
        @input="search"
        autofocus
      />
    </van-nav-bar>
    <main class="search-container h5">
      <van-cell-group v-for="user in list" class="mt1_5" :key="user.id">
        <van-cell :title="user.userName" :value="user.deptName">
          <template slot="title">
            <div class="inline-block" style="width: 70px">{{ user.userName }}</div>
            <van-tag
              v-if="user.base"
              color="#99cc99"
              round
              plain
            >{{ user.base }}</van-tag>
          </template>
          <i
            slot="icon"
            :class="['iconfont', 'mr1', user.gender === '女' ? 'icon-woman danger-light' : 'icon-man primary-light']"
          ></i>
          <van-tag v-if="user.deptName" type="primary">{{ user.deptName }}</van-tag>
        </van-cell>
        <FieldUnScore
          v-model="user.score"
          :saved.sync="user.saved"
          :id="user.id"
          :userName="user.userName"
          maxlength="3"
          placeholder="请输入分数（60~120分）"
          show-result-status
        >
          <van-button type="default" slot="button" size="small">保存</van-button>
        </FieldUnScore>
      </van-cell-group>
    </main>
  </van-popup>
</template>

<script>
import FieldUnScore from './FieldUnScore'

export default {
  name: 'ScoreSearch',
  components: {
    FieldUnScore
  },
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      show: this.value,
      list: [],
      scoredList: null,
      inputValue: ''
    }
  },
  created() {
    this.$http.post('scoresult').then(res => {
      this.scoredList = this.formatList(res, true)
    })
  },
  mounted() {
    this.triggerFocus()
  },
  methods: {
    triggerFocus() {
      this.$refs['searchInput'].$el.querySelector('input').focus()
    },
    async search(value) {
      if (!value) {
        this.list = []
        return
      }
      if (!this.scoredList) {
        this.scoredList = this.formatList(
          await this.$http.post('scoresult'),
          true
        )
      }
      let searchList = this.formatList(
        await this.$http.post(`search?username=${value}`)
      )
      searchList.forEach(searchUser => {
        this.scoredList.forEach(scoredUser => {
          if (searchUser.id === scoredUser.id) {
            searchUser.score = scoredUser.score
            searchUser.saved = true
          }
        })
      })
      this.list = searchList
    },
    formatList(list, isScoredList = false) {
      return list.map(user => ({
        id: isScoredList ? user.targetuid : user.id,
        userName: isScoredList ? user.targetname : user.username,
        base: user.jidiname,
        gender: user.sex,
        deptName: user.deptname,
        score: user.score || '',
        saved: isScoredList
      }))
    },
    close() {
      this.$emit('input', false)
      this.$emit('update-user-list')
    }
  }
}
</script>

<style lang="less" scoped>
.scoreSearch {
  display: flex;
  flex-flow: column;
  height: 100%;
  width: 100%;
  .search-nav {
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.06);
  }
  .search-container {
    flex: 1;
    overflow-y: auto;
  }
  /deep/.van-nav-bar__title {
    max-width: 68%;
    .search-field {
      height: 30px;
      margin-top: 8px;
      padding: 7px 4px;
      .van-cell {
        background: transparent;
        .van-icon-search {
          margin-right: 8px;
          color: #767676;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
